import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PageHeading from '../components/PageHeading';
import { Wrapper } from '../css_global/utils.css';
import Country from '../../common/models/Country';
import {
  ReviewsCreditCards,
  ReviewsList,
  ReviewsOrderProcessing,
  ReviewsInvitation,
  ReviewsExample,
} from '../../components_common/Reviews';

const mapStateToProps = ({ api: { countryId } }) => ({
  isUsdOrder: countryId === Country.unitedStates,
});

const Reviews = ({ isUsdOrder }) => (
  <Wrapper>
    <PageHeading text="italist Reviews" />
    <Wrapper width="93%">
      <Wrapper padding="20px 20px 0" margin="0 0 0 10px">
        <ReviewsExample />
      </Wrapper>
      <Wrapper padding="20px" margin="0 0 0 10px">
        <ReviewsInvitation />
      </Wrapper>
      <Wrapper borderTop="1px solid #000" padding="0 10px 0 0" margin="0 5px">
        <ReviewsList />
      </Wrapper>
      <Wrapper padding="20px 3px" margin="0 0 0 10px">
        <ReviewsCreditCards isUsdOrder={isUsdOrder} />
        <ReviewsOrderProcessing />
      </Wrapper>
    </Wrapper>
  </Wrapper>
);

Reviews.propTypes = {
  isUsdOrder: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(Reviews);
